export default __webpack_public_path__ + "static/release-bg-82e40ad15b3ddeb7f82dd41e3841e686.jpg";